import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useOfferUpdateShippingTypeMutation = createMutationHook(
  OffersApiClient.updateShippingType,
  {
    mutationKey: ['updateOfferShippingType'],
  },
)
